import ContextMenuItem from '../ContextMenuItem'

const SET_FILTER = 'setFilter'
const TEXT_FILTER = 'textFilter'
const NUMBER_FILTER = 'numberFilter'
const DATE_FILTER = 'dateFilter'

const FILTER_TYPES = {
    [SET_FILTER]: 'set',
    [NUMBER_FILTER]: 'number',
    [DATE_FILTER]: 'date',
    [TEXT_FILTER]: 'text',
}

/**
 * Filter by colum name context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class FilterByColumn extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return () => {
            const filterInstance = this.api.getFilterInstance(
                this.params.column.colId
            )

            const model = {
                filterType: FILTER_TYPES[filterInstance.filterNameKey],
            }

            let value = this.params.value

            if (
                !Array.isArray(value) &&
                typeof value === 'object' &&
                value !== null
            ) {
                value = this.params.column.colDef.valueFormatter(this.params)
            }

            if (filterInstance.filterNameKey === SET_FILTER) {
                model.values = [].concat(value)
            }

            if (filterInstance.filterNameKey === TEXT_FILTER) {
                model.type = 'equals'
                model.filter = value
            }

            if (filterInstance.filterNameKey === DATE_FILTER) {
                model.dateFrom = value
                model.dateTo = null
                model.type = 'equals'
            }

            filterInstance.setModel(model)

            this.api.onFilterChanged()
        }
    }

    /**
     * Determine if the menu item should be enabled/disabled.
     *
     * @return {Boolean}
     */
    disabled() {
        const colDef = this.params.column?.colDef

        if (!colDef) {
            console.error('Column definition not found.', this)
        }

        const filterInstance = this.api.getFilterInstance(colDef.colId)

        const valueGetter = colDef.valueGetter
        const valueFormatter = colDef.valueFormatter
        const selectedRows = this.params?.api?.getSelectedRows() || []

        const isEmptyString =
            typeof this.params.value === 'string' && !this.params.value
        const hasConcatenatedValues = !!valueFormatter || !!valueGetter
        const hasMultipleRowsSelected = selectedRows.length > 1
        const isDateFilter = filterInstance?.filterNameKey === DATE_FILTER

        return (
            hasMultipleRowsSelected ||
            !this.isFilterable() ||
            !colDef.cellRendererParams.extraParams?.contextMenuFilter ||
            isDateFilter ||
            isEmptyString ||
            hasConcatenatedValues
        )
    }

    /**
     * Get the filter icon html element.
     *
     * @returns {HTMLElement}
     */
    getFilterIconElement() {
        const span = document.createElement('span')

        span.role = 'presentation'

        span.classList.add('ag-icon', 'ag-icon-filter')

        return span
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Filter by Column Value'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to apply a filter on this column based on the selected value'
    }
}
